export default __webpack_public_path__ + "img/39e39b722b403c315ceb23d9cd8a2b21.gif";